var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupNotificationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EFF3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7135 26.5248C21.3266 27.4653 17.624 30.4248 17.624 33.309V37H8.06199C7.47564 37 7 36.5151 7 35.9174V33.3884C7 28.5897 16.3652 26.1695 21.056 26.1695C22.0974 26.1653 23.3686 26.2865 24.7135 26.5248ZM17.624 24C14.1018 24 11.248 21.0907 11.248 17.5C11.248 13.9093 14.1018 11 17.624 11C21.1462 11 24 13.9093 24 17.5C24 21.0907 21.1462 24 17.624 24ZM31.684 26.1653C34.4272 26.0942 36.7274 23.7952 36.8546 21.0029C36.9899 17.9514 34.6363 15.3974 31.6553 15.3389H31.4421C28.5104 15.3974 26.1773 17.872 26.2347 20.8608C26.2921 23.8495 28.7195 26.2405 31.684 26.1653ZM31.438 28.3347C28.248 28.3347 21.876 30.2701 21.876 34.1116V35.9174C21.876 36.5151 22.3517 37 22.938 37H39.938C40.5244 37 41 36.5151 41 35.9174V34.1116C41 30.2659 34.6281 28.3347 31.438 28.3347Z",
    fill: "#CBD1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupNotificationLight);
export default __webpack_public_path__ + "static/media/group-notification-light.7167046bbe5b7c4b08fc23448db47d05.svg";
export { ForwardRef as ReactComponent };